import { AuthStep } from '../types';

export const COMMON_FLOW: AuthStep[] = [AuthStep.EMAIL, AuthStep.PIN];
export const SIGN_IN_FLOW: AuthStep[] = [
  AuthStep.EMAIL_CODE,
  AuthStep.PHONE_CODE,
];
export const SIGN_IN_WITH_CODE_FLOW: AuthStep[] = [AuthStep.EMAIL_CODE];

export const SIGN_UP_HAS_ACCOUNT_FLOW: AuthStep[] = [
  AuthStep.EMAIL_CODE,
  AuthStep.PHONE_CODE,
  AuthStep.DETAILS,
  AuthStep.COMPLETE,
];

export const SIGN_UP_NO_ACCOUNT_FLOW: AuthStep[] = [
  AuthStep.PHONE,
  AuthStep.EMAIL_CODE,
  AuthStep.PHONE_CODE,
  AuthStep.DETAILS,
  AuthStep.COMPLETE,
];
